import { useEffect } from "react";
import {
  getCurrentUserAttr,
  getUserRoles,
  refreshSession,
} from "user-management/src/cognito/kahunUserAuth";
import { UserRoles } from "fe-common/graphql";
//WA for a case a user signed-up from "demo" link and didn't get its roles yet.
const signUpAttribute = "custom:signupCohort";
const signUpRoleValue = "demolink";

let needRoles = true;
export function refreshRolesForDemoSignUp() {
  if (needRoles) {
    Promise.all([getCurrentUserAttr(signUpAttribute), getUserRoles()]).then(
      ([signUpRole, roles]) => {
        // console.log("before refresh", roles);
        if (
          signUpRole === signUpRoleValue &&
          !roles.includes(UserRoles.KahunPatientDemoUsers)
        ) {
          refreshSession().then(getUserRoles);
          // .then((roles) => console.log("after refresh", roles));
        } else {
          needRoles = false;
        }
      },
    );
  }
}
export function useRefreshRoles() {
  useEffect(() => {
    refreshRolesForDemoSignUp();
  }, []);
}
